import type { CarrierRate } from '../types'
import { useCheckoutContext } from '../index'

export const useCarrierRate = (): [({ carrierRate }: { carrierRate: CarrierRate }) => void] => {
  //it just a syntax sugar for shipping options carrier rate
  const checkoutContext = useCheckoutContext()
  const [, setData] = checkoutContext.shippingOptions

  const onSelect = ({ carrierRate }: { carrierRate: CarrierRate }) => {
    setData({
      carrierRate: {
        ...carrierRate,
        hasSelected: true,
      },
      shippingFee: carrierRate.shippingAmount,
      isManualShippingRate: false,
    })
  }

  return [onSelect]
}
